import { Component } from '@angular/core';
import { NavbarComponent } from 'projects/shared/src/lib/components/navbar/navbar.component';

@Component({
  selector: 'app-header',
  imports: [NavbarComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  constructor() {}
  public get startPageUrl() {
    return '/';
  }
}
